import { useContext } from 'react';
import { BillCreationContext } from './TaskCreationProvider';

export const useTaskCreationContext = () => {
  return useContext(BillCreationContext);
};
